import { render, staticRenderFns } from "./DEmpty.vue?vue&type=template&id=0118266c&scoped=true&"
import script from "./DEmpty.vue?vue&type=script&lang=ts&"
export * from "./DEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./DEmpty.vue?vue&type=style&index=0&id=0118266c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0118266c",
  null
  
)

export default component.exports